import React, { useState, useCallback } from "react";
import useSuppliers from "../hooks/useSuppliers";
import EditableTableCell from "./EditableTableCell";
import { useErrorStore } from "components";

// Таблиця постачальників
const SuppliersTable = React.memo(() => {
  const { suppliers, updateSupplier } = useSuppliers();
  const showError = useErrorStore((state) => state.showError);
  const [editing, setEditing] = useState({ id: null, field: null, value: "" });

  // Переводить обрану комірку в режим вводу, зберігаючи її поточне значення
  const handleDoubleClick = useCallback((supId, field, currentValue) => {
    setEditing({ id: supId, field, value: String(currentValue ?? "") });
  }, []);

  // Зберігає коректні числові значення при натисканні Enter або скасовує зміни через Escape
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") {
        const { id, field, value } = editing;
        const parsed = parseFloat(value);

        // Перевірка на коректність введеного числа
        if (isNaN(parsed)) {
          showError("Введене значення має бути коректним числом");
          return;
        }

        updateSupplier(id, { [field]: parsed });
        setEditing({ id: null, field: null, value: "" });
      } else if (e.key === "Escape") {
        setEditing({ id: null, field: null, value: "" });
      }
    },
    [editing, updateSupplier, showError],
  );

  return (
    <div id="suppliers-table" className="shops-suppliers-tables">
      <h3>Таблиця постачальників</h3>
      <table className="suppliers-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Назва</th>
            <th>Коеф. транспорту</th>
            <th>Коеф. націнки</th>
            <th>Поріг замовлення</th>
            <th>Приставка</th>
            <th>Валюта</th>
            <th>Місцевий</th>
            <th>РРЦ</th>
          </tr>
        </thead>
        <tbody>
          {suppliers.length === 0 ? (
            <tr>
              <td colSpan={9} className="empty-row">
                Немає постачальників
              </td>
            </tr>
          ) : (
            suppliers.map((sup) => (
              <tr key={sup.id}>
                <td>{sup.id}</td>
                <td>{sup.name}</td>
                <EditableTableCell
                  item={sup}
                  field="transport_coefficient"
                  editing={editing}
                  onDoubleClick={handleDoubleClick}
                  onKeyDown={handleKeyDown}
                  setEditing={setEditing}
                  requiredPermission="shop-settings:edit"
                  inputType="number"
                  step="0.01"
                />
                <EditableTableCell
                  item={sup}
                  field="markup"
                  editing={editing}
                  onDoubleClick={handleDoubleClick}
                  onKeyDown={handleKeyDown}
                  setEditing={setEditing}
                  requiredPermission="shop-settings:edit"
                  inputType="number"
                  step="0.01"
                />
                <EditableTableCell
                  item={sup}
                  field="order_price_threshold"
                  editing={editing}
                  onDoubleClick={handleDoubleClick}
                  onKeyDown={handleKeyDown}
                  setEditing={setEditing}
                  requiredPermission="shop-settings:edit"
                  inputType="number"
                  step="1"
                />
                <td>{sup.presence_prefix}</td>
                <td>{sup.exchange}</td>
                <td>
                  <input className="focus-checkbox" type="checkbox" checked={!!sup.is_local} disabled />
                </td>
                <td>
                  <input className="focus-checkbox" type="checkbox" checked={!!sup.rrp} disabled />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
});

export default SuppliersTable;
